import { StyleSheet } from 'react-native-unistyles'

import InitialsAvatar from '@/components/navigation/InitialsAvatar'
import UniImage from '@/components/unistyles/UniImage'
import { useAppStore } from '@/store/useAppStore'
import { ApiRoot } from '../../../constants'

const OrganizationAvatar = ({
  logoId,
  name,
  organizationId,
  size,
}: {
  logoId?: string
  name: string
  organizationId: string
  size: number
}) => {
  const url = `${ApiRoot()}/${organizationId}/${logoId}/download?size=200`

  const accessToken = useAppStore.use.auth().accessToken

  if (!logoId) {
    return <InitialsAvatar size={size} string={name} style={styles.avatar} />
  } else {
    return (
      <UniImage
        cachePolicy="disk"
        contentFit="cover"
        source={{
          uri: url,
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }}
        style={[
          styles.avatar,
          { width: size, height: size, borderRadius: size / 2 },
        ]}
      />
    )
  }
}

const styles = StyleSheet.create(() => ({
  avatar: {
    backgroundColor: 'white',
    marginRight: 10,
  },
}))

export default OrganizationAvatar
